import $ from 'jquery';
import { register } from './../exports/theme-sections';

import embedYoutube from './../features/youtube-player';
import embedVimeo from './../features/vimeo-player';
import { popupVideo } from './../exports/popups';
import parallaxImage from './../exports/parallaxImage';
import scrollButton from './../features/scroll-button';


var selectors = {
  autoplay: '[data-video-autoplay]',
  player: '[data-player]',
};

const vimeoOptions = {
  autoplay: false,
  loop: true,
  controls: false,
  muted: true,
  playsinline: true,
};

const youtubeOptions = {
  autoplay: 1,
  cc_load_policy: 0,
  iv_load_policy: 0,
  modestbranding: 1,
  playsinline: 1,
  fs: 0,
  controls: 0,
};

const videoSection = {
  onLoad() {
    initAutoplay(this.container);
    popupVideo(this.container, this.id);
  },
  onUnload() {
    $(selectors.player, this.container).trigger('destroy');
  },
};

function initAutoplay(container) {
  const autoplay = container.querySelectorAll(selectors.autoplay);

  if (autoplay.length) {
    var videoType = autoplay[0].dataset.videoType;
    const uniqueKey = autoplay[0].dataset.player;
    if (videoType == 'vimeo') {
      let vimeoPlayerPromise = embedVimeo(uniqueKey, vimeoOptions);
      vimeoPlayerPromise.then((vimeoPlayer) => {
        return _vimeoBackground(vimeoPlayer);
      }).catch((err) => {
        console.error(err);
      });
    } else if (videoType == 'youtube') {
      let youtubePlayerPromise = embedYoutube(uniqueKey, youtubeOptions);
      youtubePlayerPromise.then((youtubePlayer) => {
        return _youtubeBackground(youtubePlayer);
      }).catch((err) => {
        console.error(err);
      });
    }
  }
}

function _youtubeBackground(youtubePlayer) {
  youtubePlayer.addEventListener('onReady', function(event) {
    event.target.mute();
    event.target.playVideo();
  });
  youtubePlayer.addEventListener('onStateChange', function(event) {
    switch (event.data) {
      case -1:
        // unstarted
        event.target.mute();
        break;
      case 0:
        // video is over, replay
        event.target.playVideo();
        break;
      case 1:
        // video is playing, set wrapepr opecity to 1
        $(event.target.getIframe())
          .closest('[data-video-autoplay]')
          .css('opacity', '1');
        break;
    }
  });
  return youtubePlayer;
}

function _vimeoBackground(player) {
  player.play().then(() => {
    // The video is playing
    $(player.element)
      .closest('[data-video-autoplay]')
      .css('opacity', '1');
  }).catch((e) => {
    console.log(e);
  });
  player.setLoop(true);
  return player;
}

register('video', [videoSection, parallaxImage, scrollButton]);
